//Material.vue



/* eslint-disable no-undef */
<template>

	<div id="material-data-container">

		<!-- Header -->
		<div id="0" class="header">

			<p class="header-element" id="header-material">Material</p>
			<p class="header-element" id="header-cost">Costs</p>
			<p class="header-element" id="header-carbon-ice">CO<sub>2</sub> e (ICE)</p>
			<p class="header-element" id="header-carbon-oekobaudat">CO<sub>2</sub> e (ÖKOBAUDAT)</p>

		</div>
		
		<!-- Concrete -->
		<div id="1" class="material">
			<p class="material-name">Concrete (C30/37)</p>

			<input class="input-price" type="text" v-model="this.materials[0].price" />
			<p class="unit">EUR/m<sup>3</sup></p>

			<!-- <input class="input-carbon" type="text" v-model="this.materials[0].carbon"> -->

			<p class="value">342</p>

			<p class="unit">kg/m<sup>3</sup></p>

			<!-- <input class="input-carbon" type="text" v-model="this.materials[0].carbon"> -->
			<p class="value">280</p>

			<p class="unit">kg/m<sup>3</sup></p>

			<button  class="update-button" @click="updateMaterial">
				Update
			</button>
		</div>

		<!-- Reinforcement Bars -->
		<div id="2" class="material">
			<p class="material-name">Reinforcement Bars</p>

			<input class="input-price" type="text" v-model="this.materials[1].price" />
			<p class="unit">EUR/kg</p>

			<!-- <input class="input-carbon" type="text" v-model="this.materials[1].carbon"> -->
			<p class="value">1.99</p>
			<p class="unit">kg/kg</p>

			<p class="value">0.683</p>

			<p class="unit">kg/m<sup>3</sup></p>

			<button class="update-button" @click="updateMaterial">
				Update
			</button>
		</div>

		<!-- Formwork -->
		<div id="3" class="material">
			<p class="material-name">Formwork</p>

			<input class="input-price" type="text" v-model="this.materials[2].price" />
			<p class="unit">EUR/m<sup>2</sup></p>

			<!-- <input id="hidden" class="input-carbon" type="text" v-model="this.materials[2].carbon"> -->
			<p id="hidden" class="value">1.99</p>
			<p id="hidden" class="unit">kg/m<sup>3</sup></p>

			<p id="hidden" class="value">1.99</p>
			<p id="hidden" class="unit">kg/kg</p>

			<button class="update-button" @click="updateMaterial">
				Update
			</button>
		</div>

		<!-- Steel -->
		<div id="4" class="material">
			<p class="material-name">Steel (S355)</p>

			<input class="input-price" type="text" v-model="this.materials[3].price" />
			<p class="unit">EUR/kg</p>

			<!-- <input class="input-carbon" type="text" v-model="this.materials[3].carbon"> -->
			<p class="value">1.55</p>
			<p class="unit">kg/kg</p>

			<p class="value">1.125</p>
			<p class="unit">kg/kg</p>

			<button class="update-button" @click="updateMaterial">
				Update
			</button>
		</div>

		<!-- Profil Steel Sheet -->
		<div id="5" class="material">
			<p class="material-name">Profil Steel Sheet (Galvanised)</p>

			<input class="input-price" type="text" v-model="this.materials[4].price" />
			<p class="unit">EUR/kg</p>

			<!-- <input class="input-carbon" type="text" v-model="this.materials[4].carbon"> -->
			<p class="value">2.76</p>
			<p class="unit">kg/kg</p>

			<p class="value">2.676</p>
			<p class="unit">kg/kg</p>

			<button class="update-button" @click="updateMaterial">
				Update
			</button>
		</div>

		<!-- Timber CLT -->
		<div id="6" class="material">
			<p class="material-name">Timber CLT</p>

			<input class="input-price" type="text" v-model="this.materials[5].price" />
			<p class="unit">EUR/m<sup>3</sup></p>

			<!-- <input class="input-carbon" type="text" v-model="this.materials[5].carbon"> -->
			<p class="value">206.96</p>
			<p class="unit">kg/m<sup>3</sup></p>

			<p class="value">134.5</p>
			<p class="unit">kg/m<sup>3</sup></p>

			<button class="update-button" @click="updateMaterial">
				Update
			</button>
		</div>

		<!-- Timber GLh -->
		<div id="7" class="material">
			<p class="material-name">Timber GLh</p>

			<input class="input-price" type="text" v-model="this.materials[6].price" />
			<p class="unit">EUR/m<sup>3</sup></p>

			<!-- <input class="input-carbon" type="text" v-model="this.materials[6].carbon"> -->
			<p class="value">225.28</p>
			<p class="unit">kg/m<sup>3</sup></p>

			<p class="value">153.1</p>
			<p class="unit">kg/m<sup>3</sup></p>

			<button class="update-button" @click="updateMaterial">
				Update
			</button>
		</div>

		<!-- <button class="btn" @click="getDataFromDb"> -->
		<button class="btn" @click="gotoDB">
			Go to Database
		</button>

	</div>

</template>



<script>

// import db from '../firebase';
import * as Firebase from '../firebase.js';

export default {
	data() {
		return {
			isAdmin: false,
			materials: [
				{
					name: 'Concrete',
					price: null,
					carbon: null
				},
				{
					name: 'Reinforcement',
					price: null,
					carbon: null
				},
				{
					name: 'Formwork',
					price: null,
					carbon: null
				},
				{
					name: 'Steel',
					price: null,
					carbon: null
				},
				{
					name: 'SteelSheet',
					price: null,
					carbon: null
				},
				{
					name: 'CLT',
					price: null,
					carbon: null
				},
				{
					name: 'GLh',
					price: null,
					carbon: null
				}
			]
		}; 
	},
	methods: {
		updateMaterial(event) {
			if(localStorage.adminStatus == '"admin"') {
				console.log('updateMaterial');
				var index = event.target.parentElement.id;
				// var selectedDoc = db.collection('materials').doc(index.toString());

				console.log(index);

				Firebase.db.collection('prices').doc(index.toString()).update( {
					price: this.materials[index-1].price,
				})
			}
			else {
				alert("You are not an admin!");
			}

			this.getDataFromDb();
		},
		getDataFromDb() {

			console.log('uploaded clicked');
			var dbData = [];

			console.log( Firebase.db.collection('prices').get().then((snapShot) => {
				snapShot.docs.forEach( doc => {
					var tempData =doc.data();
					dbData.push(tempData);
				})

				for (let i = 0; i < this.materials.length; i++) {

					console.log(dbData[i]);

					this.materials[i].price = dbData[i].price; 
					// this.materials[i].carbon = dbData[i].carbon; 
					// this.materials[i].price = dbData[i].price; 
					// this.materials[i].carbon = dbData[i].carbon; 
				}
			}) )
		},
		gotoDB() {
			const url = "https://console.firebase.google.com/project/structural-webapp-600c3/firestore/data/~2Fmaterials~2F1";
			window.open(url, '_blank').focus();
		},
		isUserAdmin() {

			// console.log('localStorage.adminStatus', localStorage.adminStatus);

			if(localStorage.adminStatus == '"admin"') {
				this.isAdmin = true;
			}
		}
	},
	mounted() {
		this.getDataFromDb();
	}
}

</script>



<style scoped>

#material-data-container {
	width: 900px;
	min-height: 200px;
	/* border: 1px solid black; */
	border-radius: 5px;;
	background: white;
	padding: 1% 3% 3% 3%;
	/* font-family: Roboto; */
	font-family: 'Roboto', sans-serif;
	font-weight: 400;
	font-size: 14px;
	box-shadow: 0px 4px 16px -4px rgba(0, 0, 0, 0.5);
}

.material {
	/* border: 1px solid black; */
	border-radius: 5px;
	padding: 0px 20px;
	justify-content: space-around;
	margin-bottom: 10px;
	box-shadow: 4px 4px 8px -4px rgba(0, 0, 0, 0.5);
}

.material input{
	width: 70px;
	border: none;
	appearance: none;
	background: rgba(141, 141, 141, 0.1);
	padding: 4px;
	border-radius: 5px;
	outline: none;
	margin-left: 10px;
	margin-right: 10px;
	color: rgba(0, 0, 0, 0.7);
	font-family: 'Roboto', sans-serif;
}

.material input:hover{
	background: rgba(141, 141, 141, 0.2);

}

.material input:focus{
	border: transparent;
	background: rgba(141, 141, 141, 0.3);
}

.material-name {
	width: 220px;
	display: inline-block;
	text-decoration: underline;
	color: rgba(0, 0, 0, 0.9);
}

.header {
	/* border: 1px solid black; */
	border-radius: 5px;
	padding: 0px 20px;
	justify-content: space-around;
	/* margin-bottom: 10px; */
	/* box-shadow: 4px 4px 8px -4px rgba(0, 0, 0, 0.5); */
}

.header-element {
	display: inline-block;
	color: rgba(0, 0, 0, 1);
	font-weight: 600;
	margin-left: 10px;
	margin-right: 140px;
}

#header-material {
	margin-right: 170px;
	margin-left: 0px;
}

#header-carbon-ice {
	margin-right: 0;
	margin-left: 10px;
}

#header-carbon-oekobaudat {
	margin-right: 0;
	margin-left: 90px;
}

.category {
	display: inline-block;
	color: rgba(0, 0, 0, 0.7);
}

.value {
	display: inline-block;
	color: rgba(0, 0, 0, 0.7);

	width: 40px;
	/* border: none;
	appearance: none; */
	/* background: rgba(141, 141, 141, 0.1); */
	padding: 4px;
	/* border-radius: 5px; */
	/* outline: none; */
	margin-left: 10px;
	margin-right: 10px;
	color: rgba(0, 0, 0, 0.7);
	font-family: 'Roboto', sans-serif;
}

.unit {
	display: inline-block;
	margin-right: 30px;
	width: 60px;
	color: rgba(0, 0, 0, 0.7);
}

.update-button {
	border-radius: 5px;
	height: 30px;
	width: 70px;
	background: rgba(84, 107, 249, 1);
	border: none;
	cursor: pointer;
	/* font-family: Roboto; */
	font-family: 'Roboto', sans-serif;
	font-weight: 300;
	color: white;
	/* box-shadow: 0px 4px 12px -4px rgba(0, 0, 0, 0.3); */
}

.update-button:hover {
	opacity: .8;
	transition: 0.1s ease-in;
}

.btn {
	border-radius: 5px;
	height: 30px;
	/* width: 70px; */
	/* background: rgba(84, 107, 249, 1); */
	background: transparent;
	border: 2px solid  rgba(84, 107, 249, 1);
	cursor: pointer;
	/* font-family: Roboto; */
	font-family: 'Roboto', sans-serif;
	font-weight: 500;
	color: rgba(84, 107, 249, 1);
	/* box-shadow: 0px 4px 12px -4px rgba(0, 0, 0, 0.3); */
}

.btn:hover {
	opacity: .8;
	transition: 0.1s ease-in;
}

#carbon-formwork {
	visibility: hidden;
}

#hidden {
	visibility: hidden;
}


</style>